import PauseMonitoringIndicator from './PauseMonitoringIndicator';

export default PauseMonitoringIndicator;
